const { default: axiosIns } = require('@/libs/axios')

const BidStrategiesService = {
  // GET - BidApiController
  async getBids() {
    return axiosIns.get('/admin/bids')
      .then(response => response.data)
  },
  // DELETE - BidApiController
  async delete(model) {
    return axiosIns.delete(`/admin/bids/${model.id}`, {
      data: {
        ...model,
      },
    }).then(response => response.data)
  },
  // PUT - BidApiController
  async updateBid(model) {
    return axiosIns.put(`/admin/bids/${model.id}`, model)
      .then(response => response.data)
  },
  // POST - BidApiController
  async createBid(model) {
    return axiosIns.post('/admin/bids', model)
      .then(response => response.data)
  },
}

export default BidStrategiesService
